import React from 'react'
import { Screen } from '~common/screen'
import { StyledScreen } from '~common/screen'
import { useIsMobile } from "~helpers/hooks/useIsMobile"

const ClientLoss = () => {
  const isMobile = useIsMobile()

  return (
    <Screen
      title={
        isMobile
          ? <span>Вы<StyledScreen.GreenText> теряете до 50%</StyledScreen.GreenText> потенциальных <br /> клиентов, если не используете сервисы для переписки</span>
          : <span>Вы<StyledScreen.GreenText> теряете до 50%</StyledScreen.GreenText> потенциальных клиентов, если не <br /> используете сервисы для переписки</span>
      }
      bottomLine
      className='client-loss'
    >
      <div className="client-loss__container">
        <div className="client-loss__coll">
          <div className="client-loss__percent-num">44<span className="client-loss__percent-symbol">%</span></div>
          <div className="client-loss__coll-text">предпочитают текстовые каналы связи голосовым</div>
        </div>
        <div className="client-loss__coll">
          <div className="client-loss__percent-num">72<span className="client-loss__percent-symbol">%</span></div>
          <div className="client-loss__coll-text">выбирают другой бренд из-за плохого сервиса и неудобного способа общения с компанией</div>
        </div>
        <div className="client-loss__coll">
          <div className="client-loss__percent-num">88<span className="client-loss__percent-symbol">%</span></div>
          <div className="client-loss__coll-text">ценят комфортное общение с компанией также, как и качество продукта</div>
        </div>
      </div>
    </Screen>
  )
}

export default ClientLoss